export enum FeedbackType {
    VALID = 'valid',
    INVALID = 'invalid',
}

export enum ValidationStatus {
    ERROR = 'error',
    SUCCESS = 'success',
    WARNING = 'warning',
}
